export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M.82 5.32c-.2-.21-.2-.54 0-.75l3.3-3.39a.5.5 0 01.75-.02L8.2 4.57c.2.21.2.54 0 .75a.49.49 0 01-.72 0L5.02 2.81v11.66c0 .29-.23.53-.51.53S4 14.76 4 14.47V2.81L1.54 5.32a.49.49 0 01-.72 0zm14.36 5.36c.2.21.2.54 0 .75l-3.3 3.39a.5.5 0 01-.75.02l-3.32-3.41c-.2-.21-.2-.54 0-.75.2-.21.52-.21.72 0l2.46 2.51V1.53c0-.29.23-.53.51-.53s.51.24.51.53v11.66l2.46-2.51c.2-.21.52-.21.72 0h-.01z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};